export default __webpack_public_path__ + "static/media/broker-icon.b5847a04.svg";